import React, { Component } from "react";

import { Row, Col, Card, CardBody, FormGroup, Button, Label, Container, Modal, Spinner, ModalHeader, ModalBody, } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import toastr from 'toastr'
import Select from "react-select";
import 'toastr/build/toastr.min.css'
import Dropzone from "react-dropzone";
import axios from "axios";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl";
import { Link } from "react-router-dom"
import default_img from "../../assets/images/default.jpg"

class FormValidations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      breadcrumbItems: [
        { title: "Users", link: "/users" },
        { title: "Add User", link: "#" },
      ],
      loading: false,
      modal_center: false,
      selectedCountry: { label: "Select Country", value: null },
      selectedState: { label: "Select State", value: null },
      selectedCity: { label: "Select City", value: null },
      StateGroup: [],
      CountriesGroup: [],
      CityGroup: [],
      user: [],
      selectedFiles: false,
    };

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000

    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.tog_center = this.tog_center.bind(this);
    this.handleSelectCountry = this.handleSelectCountry.bind(this);
    this.handleSelectState = this.handleSelectState.bind(this);
    this.handleSelectCity = this.handleSelectCity.bind(this);
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    // this.changeHandeler.bind(this);

  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/dashboard')
  }
  componentDidMount() {
    this.LoadUserData()
    this.loadCountryData()

  }
  async LoadUserData() {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      };

      await fetch(`${BaseUrl}/api/accounts/users/${obj.user.id}/`, requestOptions)
        .then(res => res.json())
        .then(
          (data) => {
            let selectedCountry = this.state.selectedCountry
            let selectedState = this.state.selectedState
            let selectedCity = this.state.selectedCity
            if (data.country) {
              selectedCountry = { label: data.country.name, value: data.country.id }
            }
            if (data.state) {
              selectedState = { label: data.state.name, value: data.state.id }
            }
            if (data.city) {
              selectedCity = { label: data.city.name, value: data.city.id }
            }
            this.setState({
              user: data,
              selectedCountry: selectedCountry,
              selectedState: selectedState,
              selectedCity: selectedCity
            })
          },
          (error) => {
            console.log(error, 'error-------------')

          }
        )
    }
  }
  async loadCountryData() {

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/location/countries/`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          let options = []
          data.map(country => {
            options.push({ label: country.name, value: country.id })
          })

          let CountriesGroup = [
            {
              label: "Country",
              options: options
            }
          ];
          this.setState({ CountriesGroup: CountriesGroup })

        },
        (error) => {
          console.log(error, 'error--------------')
        }
      )
  }
  async loadStateData(country) {

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/states/${country}/`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          let options = []
          data.map(state => {
            options.push({ label: state.name, value: state.id })
          })

          let StateGroup = [
            {
              label: "State",
              options: options
            }
          ];
          this.setState({ StateGroup: StateGroup })

        },
        (error) => {
          console.log(error, 'error--------------')
        }
      )
  }

  async loadCityData(state) {

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/cities/${state}/`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          let options = []
          data.map(city => {
            options.push({ label: city.name, value: city.id })
          })

          let CityGroup = [
            {
              label: "City",
              options: options
            }
          ];
          this.setState({ CityGroup: CityGroup })

        },
        (error) => {
          console.log(error, 'error--------------')
        }
      )
  }

  handleSelectCountry = selectedCountry => {
    this.loadStateData(selectedCountry.value)
    this.setState({ selectedCountry })
  };

  handleSelectState = selectedState => {
    this.loadCityData(selectedState.value)
    this.setState({ selectedState })
  };
  handleSelectCity = selectedCity => {
    this.setState({ selectedCity });
  };


  handleAcceptedFiles = files => {
    let file = files[0]
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: this.formatBytes(file.size)
    })
    console.log(file)

    this.setState({ selectedFiles: file });
  };
  /**
   * Formats the size
   */
  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  tog_center() {
    this.setState(prevState => ({
      modal_center: !prevState.modal_center
    }));
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  handleSubmit(e, values) {
    this.setState({ loading: true })
    const { user } = this.state

    const formData = new FormData();

    if (this.state.selectedFiles) {
      console.log("image File")
      formData.append("image", this.state.selectedFiles);
    }
    formData.append("email", values.email)
    formData.append("first_name", values.first_name)
    formData.append("last_name", values.last_name)
    formData.append("phone", values.phone)
    formData.append("country", this.state.selectedCountry.value)
    formData.append("state", this.state.selectedState.value)
    formData.append("city", this.state.selectedCity.value)
    formData.append("zip_code", values.zip_code)
    formData.append("is_superuser", user.is_superuser)
    if (values.password !== "" && values.password !== undefined && values.password === values.password1) {
      formData.append("password", values.password)
    } else {
      formData.append("password", user.password)
    }

    axios.put(
      `${BaseUrl}/api/accounts/users/${user.id}/`,
      formData,
      {
        headers: {
          "Content-type": "multipart/form-data",
        },
      }
    )
      .then(res => {

        let data = res.data;
        let authUser = JSON.parse(localStorage.getItem("authUser"))
        authUser.user.first_name = data.first_name
        authUser.user.last_name = data.last_name
        localStorage.setItem("authUser", JSON.stringify(authUser));
        toastr.success(`Profile Updated SuccessFully`, "")
        this.setState({ loading: false, user: data, modal_center: false })
      })
      .catch(err => {
        console.log(err, "----------------------error");
        this.setState({ loading: false })
      })

  }


  render() {
    const { CountriesGroup, selectedCountry, selectedState, StateGroup, selectedCity, CityGroup } = this.state;
    const { user } = this.state
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Profile" breadcrumbItems={this.state.breadcrumbItems} />
            <Row>
              <Col lg={6}>
                <Card>
                  <CardBody>
                    <Row>
                      <Col md={6}>
                        <div className="m-4">
                          {user.image ?
                            <img className="rounded avatar-xl" alt="image" src={user.image} />
                            :
                            <img className="rounded avatar-xl" alt="image" src={default_img} />
                          }
                        </div>
                      </Col>


                    </Row>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="first_name">First Name</Label>
                          <h5>{user ? user.first_name : ""}</h5>

                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="last_name">Last Name</Label>

                          <h5>{user.last_name}</h5>

                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="first_name">Email</Label>
                          <h5>{user.email}</h5>

                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="last_name">Phone Number</Label>

                          <h5>{user.phone}</h5>

                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="first_name">Country</Label>
                          <h5>{user.country ? user.country.name : ""}</h5>

                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="first_name">State</Label>
                          <h5>{user.state ? user.state.name : ""}</h5>

                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="first_name">City</Label>
                          <h5>{user.city ? user.city.name : ""}</h5>

                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="first_name">Zip Code</Label>
                          <h5>{user.zip_code ? user.zip_code : ""}</h5>

                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6} md={4} xl={3} className="mt-4">
                        {/* <Link  to="#" onClick={this.tog_center} className="me-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link> */}
                        <Button
                          type="button"
                          color="primary" className="waves-effect waves-light"
                          onClick={this.tog_center}
                        >
                          Edit Profile
                        </Button>

                        <Modal
                          isOpen={this.state.modal_center}
                          toggle={this.tog_center}
                          centered={true}
                        >
                          <ModalHeader toggle={() => this.setState({ modal_center: false })}>
                            Change Profile
                          </ModalHeader>
                          <ModalBody>
                            <AvForm onValidSubmit={this.handleSubmit}>

                              <Row>
                                <Col md="6">
                                  <div className="mb-3">
                                    <Label className="form-label" htmlFor="first_name">First Name</Label>
                                    <AvField
                                      name="first_name"
                                      placeholder="First Name"
                                      type="text"
                                      errorMessage="Enter First Name"
                                      className="form-control"
                                      id="first_name"
                                      value={user.first_name}
                                    />
                                  </div>
                                </Col>
                                <Col md="6">
                                  <div className="mb-3">
                                    <Label className="form-label" htmlFor="last_name">Last Name</Label>
                                    <AvField
                                      name="last_name"
                                      placeholder="Last Name"
                                      type="text"
                                      errorMessage="Enter Last Name"
                                      className="form-control"
                                      id="last_name"
                                      value={user.last_name}
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col md="6">
                                  <div className="mb-3">
                                    <AvField
                                      name="email"
                                      label="E-Mail"
                                      placeholder="Enter Valid Email"
                                      type="email"
                                      errorMessage="Invalid Email"
                                      value={user.email}
                                    />
                                  </div>
                                </Col>
                                <Col md="6">
                                  <div className="mb-3">
                                    <AvField
                                      name="phone"
                                      label="Contact No."
                                      placeholder="Enter Only number"
                                      type="number"
                                      errorMessage="Enter Only Number"
                                      value={user.phone}
                                      validate={{
                                        pattern: {
                                          value: "^[0-9]+$",
                                          errorMessage: "Only Numbers"
                                        },
                                        maxLength: {
                                          value: 15,
                                          errorMessage: "Numbers must be less than 16 digit"
                                        },
                                        minLength: {
                                          value: 10,
                                          errorMessage: "Numbers must be Grater than 9 digit"
                                        }
                                      }}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="6">
                                  <div className="mb-3">
                                    <Label className="form-label">Country</Label>
                                    <Select
                                      value={selectedCountry}
                                      onChange={this.handleSelectCountry}
                                      options={CountriesGroup}
                                      classNamePrefix="select2-selection"
                                    />

                                  </div>
                                </Col>
                                <Col md="6">
                                  <div className="mb-3">
                                    <Label className="form-label">State</Label>
                                    <Select
                                      value={selectedState}
                                      onChange={this.handleSelectState}
                                      options={StateGroup}
                                      classNamePrefix="select2-selection"
                                    />

                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="6">
                                  <div className="mb-3">
                                    <Label className="form-label">City</Label>
                                    <Select
                                      value={selectedCity}
                                      onChange={this.handleSelectCity}
                                      options={CityGroup}
                                      classNamePrefix="select2-selection"
                                    />

                                  </div>
                                </Col>
                                <Col md="6">
                                  <div className="mb-3">
                                    <AvField
                                      name="zip_code"
                                      label="Pin Code"
                                      placeholder="Enter Only number"
                                      type="number"
                                      value={user.zip_code}
                                      errorMessage="Enter Only Number"
                                      validate={{
                                        required: { value: true },

                                        maxLength: {
                                          value: 6,
                                          errorMessage: "Numbers must be less than 7 digit"
                                        },
                                        minLength: {
                                          value: 6,
                                          errorMessage: "Numbers must be Grater than 5 digit"
                                        }
                                      }}
                                    />
                                  </div>
                                </Col>

                              </Row>
                              {user.is_superuser ? (
                                <Row>
                                  <Col md="6">
                                    <div className="mb-3">
                                      <Label>Change Password</Label>
                                      <AvField
                                        name="password"
                                        type="password"
                                        placeholder="Password"
                                        errorMessage="Enter password"
                                        autoComplete="new-password"
                                      />
                                    </div>
                                  </Col>
                                  <Col md="6">
                                    <div className="mb-3">
                                      <Label>Confirm Password</Label>
                                      <AvField
                                        name="password1"
                                        type="password"
                                        placeholder="Re-type Password"
                                        errorMessage="Enter Re-password"
                                        validate={{
                                          match: { value: "password" }
                                        }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              ) : ('')}
                              <Row>
                                <Col md="12">
                                  <Dropzone
                                    accept='.jpeg,.jpg,.JPG,.JPEG,.PNG,.png'
                                    maxSize={1000000}
                                    onDrop={(acceptedFiles) => {

                                      this.handleAcceptedFiles(acceptedFiles)
                                    }}


                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div className="dropzone">
                                        <div
                                          className="dz-message needsclick"
                                          {...getRootProps()}
                                        >
                                          <input {...getInputProps()} />
                                          <div className="mb-3">
                                            <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                          </div>
                                          <h6>Drop only .jpeg/.jpg/.png Images here or click to upload.</h6>
                                          <h6>Images size is less than 1 MB.</h6>
                                        </div>
                                      </div>
                                    )}
                                  </Dropzone>
                                  <div
                                    className="dropzone-previews mt-3"
                                    id="file-previews"
                                  >
                                    {/* {this.state.selectedFiles.map((f, i) => {
                                    return ( */}
                                    {this.state.selectedFiles ?
                                      <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={"-file"}
                                      >
                                        <div className="p-2">
                                          <Row className="align-items-center">
                                            <Col className="col-auto">
                                              <img
                                                data-dz-thumbnail=""
                                                height="80"
                                                className="avatar-sm rounded bg-light"
                                                alt={this.state.selectedFiles.name}
                                                src={this.state.selectedFiles.preview}
                                              />
                                            </Col>
                                            <Col>
                                              <Link
                                                to="#"
                                                className="text-muted fw-bold"
                                              >
                                                {this.state.selectedFiles.name}
                                              </Link>
                                              <p className="mb-0">
                                                <strong>{this.state.selectedFiles.formattedSize}</strong>
                                              </p>
                                            </Col>
                                          </Row>
                                        </div>
                                      </Card> : ""}


                                  </div>
                                </Col>
                              </Row>





                              <FormGroup className="mb-0">
                                {this.state.loading ? (
                                  <Spinner className="me-2 mt-2" color="primary" />
                                ) : (
                                  <div>

                                    <Button type="submit" color="primary" className="me-1">
                                      Submit
                                    </Button>
                                  </div>
                                )}
                              </FormGroup>
                            </AvForm>
                          </ModalBody>
                        </Modal>
                      </Col>
                    </Row>


                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default FormValidations;
